import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { LeftPanel, MainContainer, RightPanel } from "./LoginLayout";
import { StackPanelLogo } from "./StackCarePanelLogo";
import { useTranslation } from "react-i18next";
import {
  Typography,
  makeStyles,
  createStyles,
  Theme,
  Button,
  Link,
} from "@material-ui/core";
import { Views } from "../../helpers/constants";
import { useHistory } from "react-router-dom";
import { IAppState } from "../../helpers/store";
import AccountManagementHeader from "./AccountManagementHeader";
import { logout } from "./loginSlice";
import LeftPanelFooter from "./LeftPanelFooter";
import { supportEmail } from "../../services/constants";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainText: {
      color: theme.palette.dark.main,
      fontWeight: "bold",
      fontSize: "2rem",
      width: "480px",
      marginTop: "90px",
    },
    subText: {
      color: theme.palette.dark.main,
      fontSize: "1rem",
      width: "480px",
      marginTop: "35px",
      lineHeight: "1.6rem",
    },
    loginButton: {
      marginTop: "20px",
      width: "480px",
      height: "45px",
    },
    buttonText: {
      color: theme.palette.dark.main,
      fontSize: "1rem",
      textTransform: "none",
    },
    supportText: {
      color: theme.palette.dark.main,
      marginTop: "22px",
      width: "480px",
      fontSize: "1rem",
      lineHeight: "1.6rem",
    },
    linkText: {
      textDecoration: "none !important",
      color: "primary",
    },
  })
);

export default function LoginConfirmation() {
  /* ---- Hooks ---- */
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  /* ---- Utils ---- */
  const handleBackToLogin = () => {
    dispatch(logout());
    history.push(Views.LOGIN);
  };

  const loginEmailSent: boolean = useSelector(
    (state: IAppState) => state.loginState.loginEmailSent
  );

  const loginEmail: string = useSelector(
    (state: IAppState) => state.loginState.email
  );

  return (
    <MainContainer>
      <LeftPanel>
        <StackPanelLogo />
        <AccountManagementHeader />
        <LeftPanelFooter />
      </LeftPanel>
      {loginEmailSent && (
        <RightPanel>
          <Typography className={classes.mainText}>
            {t("email_link_maintext")}
          </Typography>
          <Typography className={classes.subText}>
            {t("email_link_subtext", {
              email: loginEmail,
            })}
          </Typography>
          <Button
            type="submit"
            variant="outlined"
            size="large"
            className={classes.loginButton}
            onClick={handleBackToLogin}
          >
            <Typography className={classes.buttonText}>
              {t("use_different_email")}
            </Typography>
          </Button>
          <Typography className={classes.supportText}>
            {t("support_email_start")}
            <Link
              className={classes.linkText}
              color="primary"
              href={`mailto: ${supportEmail}`}
            >
              {supportEmail}
            </Link>
            {t("support_email_end")}
          </Typography>
        </RightPanel>
      )}
    </MainContainer>
  );
}
